import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { ILocalization } from 'bernie-l10n';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { SearchCriteriaModel } from 'stores/models';

import { LoyaltyMessagingModel } from 'models';
import { PropertySearch } from '__generated__/api/types';

import { classNames } from 'uitk-react-utils';
import { UitkText } from 'uitk-react-text';

import { HeaderMessageLink } from './header-message-link';
import { SWPToggle } from 'components/common/swp-toggle';

const defaultClasses = 'pwa-theme--grey-700 all-b-padding-one';

export enum ResultsHeaderMessageAlignment {
  Left = 'uitk-type-left',
  Center = 'uitk-type-center'
}

export interface ResultsHeaderProps {
  messageAlignment: ResultsHeaderMessageAlignment;
  headerSectionPaddingClasses?: string;
  summaryMessages?: PropertySearch.ResultsSummary[];
  isLoading: boolean;
  l10n: ILocalization;
  loyaltyMessagingModel?: LoyaltyMessagingModel;
  searchCriteria: SearchCriteriaModel;
  classes?: string;
}

export const ResultsHeader: React.FunctionComponent<ResultsHeaderProps> = props => {
  const { headerSectionPaddingClasses, messageAlignment, summaryMessages, isLoading, l10n, loyaltyMessagingModel, searchCriteria } = props;
  const multiItem = searchCriteria && searchCriteria.misId;
  const lob = multiItem ? 'multiItem' : 'hotels';
  const classes = props.classes || defaultClasses;

  if (isLoading) {
    return (
      <p className={`${classes} ${messageAlignment} all-b-padding-two`}>{l10n.formatText(`${lob}.searchResults.loadingMessage.text`)}</p>
    );
  }

  const headerClasses = classNames(`tools__summary ${headerSectionPaddingClasses}`);

  return (
    <header className={headerClasses}>
      <SWPToggle model={loyaltyMessagingModel} searchCriteria={searchCriteria} />
      <HeaderMessages messageAlignment={messageAlignment} summaryMessages={summaryMessages} classes={classes} />
    </header>
  );
};
ResultsHeader.displayName = 'ResultsHeader';

export interface HeaderMessagesProps {
  messageAlignment: ResultsHeaderMessageAlignment;
  summaryMessages?: PropertySearch.ResultsSummary[];
  classes?: string;
}

export const HeaderMessages: React.FunctionComponent<HeaderMessagesProps> = props => {
  const { messageAlignment, summaryMessages } = props;
  const classes = props.classes || defaultClasses;

  if (!summaryMessages || summaryMessages.length === 0) {
    return null;
  }

  return (
    <div className="uitk-flex uitk-flex-column s-t-padding-one" data-stid="results-header-messages">
      {summaryMessages.map((summaryMessage, index) => {
        const { link, value } = summaryMessage;

        if (!value) {
          return null;
        }

        return (
          <div className={`${classes} ${messageAlignment}`} data-stid="results-header-message" key={`header-message-${index}`}>
            {link ? (
              <HeaderMessageLink {...summaryMessage} />
            ) : (
              <UitkText size={200} weight="bold">
                {value}
              </UitkText>
            )}
          </div>
        );
      })}
    </div>
  );
};
HeaderMessages.displayName = 'HeaderMessages';
